import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Zap, Gift, ArrowRight } from 'lucide-react';
import { API } from '../App';

export default function ReferralLanding() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const code = params.get('code');
  const [invite, setInvite] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!code) { setLoading(false); return; }
    API.get(`/api/invites/${code}`)
      .then(r => setInvite(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [code]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#F5F1E8] flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">
        <div className="w-16 h-16 mx-auto mb-6 bg-[#FF4D00]/10 flex items-center justify-center rounded-full">
          <Gift className="w-8 h-8 text-[#FF4D00]" />
        </div>

        {loading ? (
          <div className="animate-pulse h-20 bg-[#1E1E1E]" />
        ) : !invite?.valid ? (
          <div>
            <h1 className="text-2xl font-bold font-display uppercase mb-2">Invalid Referral</h1>
            <p className="text-sm text-[#A0A0A0] mb-6">This referral link is expired or invalid.</p>
            <button onClick={() => navigate('/signup')}
              className="px-6 py-3 bg-[#FF4D00] text-[#0A0A0A] font-bold font-display uppercase tracking-wider">
              Sign Up Anyway
            </button>
          </div>
        ) : (
          <div>
            <h1 className="text-2xl font-bold font-display uppercase mb-2">You've Been Referred!</h1>
            <p className="text-sm text-[#A0A0A0] mb-4">
              A friend invited you to try Fray — multi-model AI debates.
            </p>

            <div className="p-4 mb-6 bg-[#1E1E1E] border border-[#FF4D00]/20">
              <div className="flex items-center justify-center gap-3">
                <Zap className="w-6 h-6 text-[#FF4D00]" />
                <span className="text-2xl font-bold font-mono text-[#FF4D00]">+50</span>
                <span className="text-sm text-[#A0A0A0]">bonus credits</span>
              </div>
              <p className="text-[10px] text-[#A0A0A0] mt-2 font-mono">
                Both you and your referrer get 50 credits when you complete your first fray
              </p>
            </div>

            <button onClick={() => navigate(`/signup?invite=${code}`)}
              className="w-full py-3 min-h-[44px] bg-[#FF4D00] text-[#0A0A0A] font-bold font-display uppercase tracking-wider hover:bg-[#FF6B33] transition-colors flex items-center justify-center gap-2"
              data-testid="claim-referral">
              Claim Your Credits <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
